import { checkboxInputCss } from "./checkbox";
import { emailInputCss } from "./email";
import { rangeInputCss } from "./range";
import { textInputCss } from "./text";

export const styles = {
  //   button: buttonInputCss,
  checkbox: checkboxInputCss,
  //   color: colorInputCss,
  //   date: dateInputCss,
  //   "datetime-local": datetimeLocalInputCss,
  email: emailInputCss,
  //   file: fileInputCss,
  //   hidden: hiddenInputCss,
  //   image: imageInputCss,
  //   month: monthInputCss,
  //   number: numberInputCss,
  //   password: passwordInputCss,
  //   radio: radioInputCss,
  range: rangeInputCss,
  //   reset: resetInputCss,
  //   search: searchInputCss,
  //   submit: submitInputCss,
  //   tel: telInputCss,
  text: textInputCss,
  //   time: timeInputCss,
  //   url: urlInputCss,
  //   week: weekInputCss,
};
